import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import DiscussionHero from 'flarum/forum/components/DiscussionHero';
import LinkButton from 'flarum/common/components/LinkButton';
import Link from 'flarum/common/components/Link';
import Icon from 'flarum/common/components/Icon';
import classList from 'flarum/common/utils/classList';
import { canViewKnowledgeBase, knowledgeBaseCategory, knowledgeBaseTagIds } from '../common/utils/knowledgeBase';
export default function addKnowledgeBase() {
  // "Knowledge base" link below "All Discussions".
  extend(IndexSidebar.prototype, 'navItems', function (items) {
    if (!canViewKnowledgeBase() || !knowledgeBaseTagIds().length) return;
    items.add('knowledgeBase', m(LinkButton, {
      href: app.route('support.knowledgeBase'),
      icon: "fas fa-book"
    }, app.translator.trans('soup-97-support.forum.nav.knowledge_base')), 95);
  });

  // Articles reuse the discussion page, with an extra class for a cleaner
  // layout (see less/forum/article.less).
  extend(DiscussionPage.prototype, 'view', function (vdom) {
    const discussion = app.current.get('discussion');
    if (!discussion || !knowledgeBaseCategory(discussion)) return;
    const attrs = vdom.attrs;
    attrs.className = classList(attrs.className, 'DiscussionPage--article');
  });

  // Breadcrumb back to the article's knowledge base category.
  extend(DiscussionHero.prototype, 'items', function (items) {
    const category = knowledgeBaseCategory(this.attrs.discussion);
    if (!category) return;
    items.add('knowledgeBase', m("nav", {
      className: "KnowledgeBaseBreadcrumb"
    }, m(Link, {
      href: app.route('support.knowledgeBase')
    }, m(Icon, {
      name: "fas fa-book"
    }), " ", app.translator.trans('soup-97-support.forum.knowledge_base.title')), m("span", {
      className: "KnowledgeBaseBreadcrumb-separator"
    }, "\u203A"), m(Link, {
      href: app.route('support.knowledgeBase.tag', {
        slug: category.slug()
      })
    }, category.name())), 20);
  });
}